;((): void => {
    for (const image of document.getElementsByTagName("img")) {
        image.addEventListener("error", (): void => {
            image.classList.add("failed")
        })

        if (image.complete && image.naturalWidth === 0) {
            image.classList.add("failed")
        }
    }
})()
